import { createContext, useContext, useState } from "react";

const UserRoleContext = createContext();

export const UserRoleProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(
    localStorage.getItem("check2UserRole") || null,
  );
  // console.log("UserRoleProvider initialized with role:", userRole)

  return (
    <UserRoleContext.Provider value={{ userRole, setUserRole }}>
      {children}
    </UserRoleContext.Provider>
  );
};

export const useUserRole = () => {
  const context = useContext(UserRoleContext);

  if (!context) {
    throw new Error("useUserRole must be used within UserRoleProvider");
  }

  return context;
};
